import piniaPersistedstate from 'pinia-plugin-persistedstate'
import { createPinia } from 'pinia';
const pinia = createPinia()
pinia.use(piniaPersistedstate)

import { createApp, defineAsyncComponent } from 'vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import App from './App.vue';
import mitt from 'mitt';
import router from './router/router';
import router_landing from '@/router/router_landing'

import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css'
import "bootstrap"

import '@/assets/style.scss';

import {customRu} from "@/helpers/elCustomLocale";

const emitter = mitt();

// Включаем обновление локали для ElementPlus
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/ru';

dayjs.extend(updateLocale);
dayjs.updateLocale('ru', {
  weekStart: 1, // Понедельник
});

const app = createApp(App);
app.use(pinia)
app.provide('emitter', emitter)
app.use(ElementPlus, {locale: customRu,})

const landings = {
  // 'test4.tld': { view: 'MovieView', props: { id: 55, series: [6, 7, 8], serie: "3:7" }},
  'balerina.goodmovie.net': { view: 'MovieView', props: { id: 13 }},
  'lilo-i-stich.goodmovie.net': { view: 'MovieView', props: { id: 60 }},
  'plagiator.goodmovie.net': { view: 'MovieView', props: { id: 56 }},
  'kraken.goodmovie.net': { view: 'MovieView', props: { id: 61 }},
  'bolshe-chem-futbol.goodmovie.net': { view: 'MovieView', props: { id: 59 }},
  'formula-1.goodmovie.net': { view: 'MovieView', props: { id: 52 }},
  'kak-priruchit-drakona.goodmovie.net': { view: 'MovieView', props: { id: 40 }},
  'moy-papa-medved.goodmovie.net': { view: 'MovieView', props: { id: 58 }},
  'tribogatirya2.goodmovie.net': { view: 'MovieView', props: { id: 72 }},
  'neodnadoma2.goodmovie.net': { view: 'MovieView', props: { id: 73 }},
  'test4.tld': { view: 'MovieView', props: { id: 73 }},

  'wednesday.goodmovie.net': { view: 'MovieView', props: { id: 66, series: [6, 2], serie: "2:2" }},
  'eterna.goodmovie.net': { view: 'MovieView', props: { id: 62, series: [6], serie: "1:6" }},
  'slovo-patsana.goodmovie.net': { view: 'MovieView', props: { id: 63, series: [8], serie: "1:8" }},
  'zimorodok.goodmovie.net': { view: 'MovieView', props: { id: 64, series: [118, 27, 27], serie: "3:27" }},
  'dva-kholma.goodmovie.net': { view: 'MovieView', props: { id: 65, series: [13, 13, 13], serie: "3:13" }},
  'osnovanie.goodmovie.net': { view: 'MovieView', props: { id: 70, series: [10, 10, 10], serie: "3:10" }},
  'dexter.goodmovie.net': { view: 'MovieView', props: { id: 71, series: [10], serie: "1:10"}},
  'mosgaz-11.goodmovie.net': { view: 'MovieView', props: { id: 69, series: [8], serie: "1:8"}},
  'khirurg.goodmovie.net': { view: 'MovieView', props: { id: 68, series: [8], serie: "1:8" }},
  'tsiniki.goodmovie.net': { view: 'MovieView', props: { id: 67, series: [10], serie: "1:10" }},
}

const landing = landings[window.location.hostname]
if (window.location.hostname.includes('goodmovie.net')) {
  localStorage.setItem("dreams_ref", '8');
}
landing ? app.use(router_landing, landing): app.use(router);

app.mount('#app');

import { useStore } from "@/store/store";
const store = useStore()
store.setLoaded()
store.applyTheme()




